import NavList from '@constants/nav-list';
import { create } from 'zustand';

const initialState = {
  navListItems: NavList,
  isSidebarCollapsed: false,
  isMobileOrTablet: false,
};

const useAppStore = create((set) => ({
  ...initialState,
  actions: {
    toggleSidebarAction: () => set((state) => {
      if (state.isMobileOrTablet) {
        return ({ isSidebarCollapsed: !state.isSidebarCollapsed });
      }
      return state;
    }),
    setMobileOrTabletAction: (isMobileOrTablet) => set(() => ({ isMobileOrTablet })),
  },
}));

export const useAppActions = () => useAppStore.getState().actions;
export const useNavListItems = () => useAppStore((state) => state.navListItems);
export const useIsSidebarCollapsed = () => useAppStore((state) => state.isSidebarCollapsed);
export const useIsMobileOrTablet = () => useAppStore((state) => state.isMobileOrTablet);
